import { render, staticRenderFns } from "./TemplateMarketView.vue?vue&type=template&id=0dacdf4e&scoped=true"
import script from "./TemplateMarketView.vue?vue&type=script&lang=js"
export * from "./TemplateMarketView.vue?vue&type=script&lang=js"
import style0 from "./TemplateMarketView.vue?vue&type=style&index=0&id=0dacdf4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dacdf4e",
  null
  
)

export default component.exports